import { useCallback } from 'react';

import { useSidebarEvents } from '../../service';
import { useMainActions } from '../../store';

export const useHandlers = () => {
  const { trackNavigationItemClicked } = useSidebarEvents();
  const mainActions = useMainActions();

  const handleLinkClick = useCallback(
    (linkItem) => {
      trackNavigationItemClicked({ label: 'Custom Folder', folderName: linkItem.label });

      if (!linkItem.isChildItem && !linkItem.disableNavigation) {
        mainActions.collapseAll();
      }
    },
    [mainActions, trackNavigationItemClicked]
  );

  return {
    handleLinkClick,
  };
};
